// extracted by mini-css-extract-plugin
module.exports = {"link":"ShortLink__link___1y5y7"};